import { createContext, useContext, useEffect } from "react";

// Quem guarda o título é o Layout; a tela só informa. Sem Layout em volta, não faz nada.
export const PageHeaderContext = createContext(() => {});

/**
 * Título e breadcrumb da tela no Header da lib (`h2_medium`, como no ft-app-web).
 * Sem chamada, o Header mostra "Olá, Nome". `breadcrumb`: [{ page, route }].
 * As telas passam a usar ao serem refeitas (R.7 em diante).
 */
export function usePageHeader({ title, breadcrumb } = {}) {
  const setPageHeader = useContext(PageHeaderContext);
  const breadcrumbKey = JSON.stringify(breadcrumb || []);

  useEffect(() => {
    setPageHeader(title ? { title, breadcrumb: breadcrumb || [] } : null);
    return () => setPageHeader(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, breadcrumbKey]);
}
